let setVendors = (state, vendors) => {
	state.vendors = vendors;
};

let setPreferredVendors = (state, preferredVendors) => {
	state.preferredVendors = preferredVendors;
};

let setVendor = (state, vendor) => {
	let arrayCopy = state.vendors.slice();
	let indexOfVendor = arrayCopy.findIndex(x => x.id === vendor.id);
	arrayCopy[indexOfVendor] = vendor;
	state.vendors = arrayCopy;
};

export default { setVendors, setPreferredVendors, setVendor };
